import { EntityApi } from "../../services/ApiPlatform";

export abstract class CategoryApi extends EntityApi {
    protected static GET_COLLECTION = "/api/categories";

    protected static POST_COLLECTION = "/api/categories";

    protected static GET_ITEM = "/api/categories/{id}";

    protected static PUT_ITEM = "/api/categories/{id}";

    protected static PATCH_ITEM = "/api/categories/{id}";

    protected static DELETE_ITEM = "/api/categories/{id}";
}
